module.exports = __webpack_public_path__ + "img/user.65d85d36.png";